module.exports = __webpack_public_path__ + "static/media/pdf-chapter-icon.4aaaf45a.svg";